import { SingleSelect, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import { items as originalItems } from "designSystemLegacy/data";
import { sortedByGroupItems as originalGroupedItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";

export default () => {
	const items = cloneDeep(originalItems);
	items[0].invalid = true;

	const groupedItems = cloneDeep(originalGroupedItems);
	groupedItems[0].group = "";
	groupedItems[0].invalid= true;

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="No groups" />
			<Text semiBold text="Grouped" />
			<SingleSelect
				options={items}
				value={items[0]}
			/>
			<SingleSelect
				grouped
				options={groupedItems}
				value={groupedItems[0]}
			/>
		</CssColumnGrid>
	);
};